/* src/app/pages/contractor-detail/contractor-detail.component.scss */
@keyframes ldio-okxz8jkbhq-1 {
  0% {
    top: 12.5px;
    height: 75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-2 {
  0% {
    top: 15.625px;
    height: 68.75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-3 {
  0% {
    top: 18.75px;
    height: 62.5px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
.ldio-okxz8jkbhq div {
  position: absolute;
  width: 12px;
}
.ldio-okxz8jkbhq div:nth-child(1) {
  left: 19px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-1 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.2s;
}
.ldio-okxz8jkbhq div:nth-child(2) {
  left: 44px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-2 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.1s;
}
.ldio-okxz8jkbhq div:nth-child(3) {
  left: 69px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-3 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: undefineds;
}
.loadingio-spinner-pulse-uq8kufhdmv {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-okxz8jkbhq {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
}
.ldio-okxz8jkbhq div {
  box-sizing: content-box;
}
._tooltip {
  display: none;
  position: absolute;
  margin-top: 14px;
  font-family: "Helvetica Neue", serif;
  font-size: 13px;
  background-color: #00b7bd;
  padding: 7px;
  color: #FFF;
}
.page-content {
  padding-top: 100px;
  font-family: "Gotham-Book", serif;
  background-size: cover;
  font-size: 18px;
  color: #333333;
}
.cbm-name {
  font-family: "Gotham-Bold", serif;
  font-size: 30px;
  color: #284D76;
}
.star {
  height: 22px;
  width: 22px;
}
.data-label {
  font-weight: bold;
  color: #9A9B9C;
  font-size: 18px;
}
.services {
  width: 460px;
}
.review-header {
  font-size: 22px;
  color: #284D76;
  font-family: "Gotham-Bold", serif;
  font-weight: bold;
  margin-bottom: 20px;
}
.review-item {
  display: flex;
  flex-direction: row;
  padding: 20px;
  border-bottom: 1px solid #EAEAEA;
}
.review-meta {
  width: 305px;
}
.r-name,
.r-date {
  font-size: 13px;
  font-family: "Gotham-Book", serif;
  color: #797A7B;
}
.r-message {
  font-size: 18px;
  width: 752px;
  text-align: justify;
}
.cities {
  display: inline-block;
  text-align: justify;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 300px;
}
.expand {
  display: block;
  width: auto;
  height: auto;
  white-space: pre-wrap;
}
.view-more {
  margin-left: 10px;
  font-family: "Gotham-Book", serif;
  font-weight: bold;
  display: inline-block;
  text-align: justify;
  overflow: hidden;
  color: #5F96BA;
  cursor: pointer;
  text-decoration: underline;
}
.view-more:hover {
  text-decoration: none;
  color: #5F96BA;
}
@media screen and (max-width: 1000px) {
  .services {
    width: 100%;
  }
  .cities {
    width: 80vw;
  }
  .review-meta {
    width: 100%;
  }
  .r-message {
    width: 100%;
  }
  .review-item {
    flex-direction: column;
  }
}
/*# sourceMappingURL=contractor-detail.component.css.map */
